/** @jsx jsx */

import { Fragment as _, useRef, useEffect } from 'react';

import { css, jsx } from '@emotion/core';
import { useSelector } from 'react-redux';
import { EditWrapper0, EditWrapper1, EditWrapper2 } from './EditWrappers';
import svgPlaceholder from 'assets/animations/placeholder.js';
import isIE from 'services/isIE';
import { State } from 'store/store';
import ReactBodymovin from 'react-lottie';

const SVG = ({ id, focusedNodeId, src, editWrapperType = 0, ...rest }) => {
  let animationData;

  if (src) {
    try {
      animationData = JSON.parse(src);
    } catch {
      animationData = svgPlaceholder;
    }
  } else {
    animationData = svgPlaceholder;
  }

  const selected = useSelector((state: State) => {
    return id === state?.focusedNodeId;
  });

  const svg = useRef<HTMLSpanElement>(null);
  const reactBodyMovin = useRef<any>(null);

  const bodymovinOptions = {
    loop: true,
    autoplay: true,
    prerender: true,
    renderer: 'svg',
    animationData,
  };

  const hasAnimationData = Object.keys(animationData).length > 0;

  useEffect(() => {
    if (!isIE()) return;
    if (!svg.current) return;

    const svg_ = svg.current.querySelector('svg')!;

    if (!svg_) {
      return;
    }

    svg_.removeAttribute('width');
    svg_.removeAttribute('height');

    const onResize = () => {
      svg_.style.width = '100%';
      svg_.style.height = `${window.innerHeight / 2}px`;
    };
    onResize();
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  });

  useEffect(() => {
    if (!reactBodyMovin.current) {
      return;
    }

    const { el } = reactBodyMovin.current;

    ['title', 'role', 'aria-label', 'tabindex'].forEach(entry => {
      el.removeAttribute(entry);
    });
  }, []);

  const EditWrapper = window.dev()
    ? ({ children }) => {
        return [
          <EditWrapper0 id={id} selected={selected}>
            {children}
          </EditWrapper0>,
          <EditWrapper1 id={id} selected={selected}>
            {children}
          </EditWrapper1>,
          <EditWrapper2 id={id} selected={selected}>
            {children}
          </EditWrapper2>,
        ][editWrapperType];
      }
    : ({ children }) => <_>{children}</_>;

  return (
    <span
      ref={svg}
      css={css`
        width: 100%;
        height: 100%;
        svg {
          max-height: 50vh !important;
        }
      `}
    >
      <EditWrapper>
        {hasAnimationData ? (
          <div
            css={css({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            })}
          >
            <div>
              <ReactBodymovin ref={reactBodyMovin} options={bodymovinOptions} />
            </div>
          </div>
        ) : (
          ''
        )}
      </EditWrapper>
    </span>
  );
};

export default SVG;
